module.exports = __webpack_public_path__ + "img/thumb-knoflooksaus-met-ovenaardappelen.bde62c72.jpeg";